'use strict';

customerZone

    .controller('MyUsageController', ['$scope', '$log', '$window', '$location', 'config', 'Session', 'BalanceService',
        function($scope, $log, $window, $location, config, session, BalanceService){

            var self = this;

            // used in the template, for the call-to-action button
            self.subscriptionsUrl = config.mainUrls.subscriptions;

            self.balance = BalanceService.balance;
            BalanceService.refresh();

            $scope.$on('balanceRefreshed', function(event, balance){
                self.balance = balance;
                self.migration = getMigrationInfo();
            });

            var getMigrationInfo = function(){
                var subscriber = session.subscriber();
                if (subscriber && subscriber.state === jim.SubscriberState.migrating && subscriber.oldProduct) {
                    return {
                        oldProduct: subscriber.oldProduct.name,
                        newProduct: subscriber.product.name,
                        date: subscriber.oldProductEndDate
                    };
                }
                return undefined;
            };
        }]);
